import React from 'react'
import clsx from 'clsx'

import useStyles from '../styles'

const ConnectionPoints = ({ connectionTypes }) => {
  const classes = useStyles()
  const points = []

  if (connectionTypes.hasIncomingVertical) {
    points.push(
      <div
        key="top"
        className={clsx(classes.connectionPoint, classes.connectionPointTop)}
      />,
    )
  }

  if (connectionTypes.hasOutgoingVertical) {
    points.push(
      <div
        key="bottom"
        className={clsx(classes.connectionPoint, classes.connectionPointBottom)}
      />,
    )
  }

  if (connectionTypes.hasIncomingHorizontal) {
    points.push(
      <div
        key="left"
        className={clsx(classes.connectionPoint, classes.connectionPointLeft)}
      />,
    )
  }

  if (connectionTypes.hasOutgoingHorizontal) {
    points.push(
      <div
        key="right"
        className={clsx(classes.connectionPoint, classes.connectionPointRight)}
      />,
    )
  }

  return points
}

export default ConnectionPoints
